import * as S from './styled'

function ErrorComponent ({children}) {
  return <S.Error>{children}</S.Error>
}

export default ErrorComponent
